module.exports = __webpack_public_path__ + "img/iconAddressGreen.4d655957.svg";